const rules = [
  [
    /\@([\w]+)\b/g,
    '<a href="#" class="suggestions">@$1</a> ',
  ],
];

function generateUserLink(user, dataSource) {
  const data = dataSource(() => ({username}) => this.find(username, user).substring(1))
  return `<a href="#" data-reference="${data.id}" data-reference-type="user" class="suggestions">${user}</a> `
}

function generateFileLink(file, dataSource) {
  const data = dataSource(() => ({name}) => this.find(name, file).substring(1))
  return `<a href="#" data-reference="${data.id}" data-reference-type="file" class="suggestions">${file}</a> `
}
export function parseSuggestions(content, configuration) {
  let html = content;
  const words = html.split(/\s+/)

  words.forEach(w => {
    switch (w[0]) {
      case '@':
        html = html.replace(w, generateUserLink(w, configuration.usersSuggestion.dataSource))
        break;
      case '#':
        html = html.replace(w, generateFileLink(w, configuration.filesSuggestion.dataSource))
        break;
    }
  })
  return html
}
